module.exports = __webpack_public_path__ + "static/cer_dor_2-c67c72a026ab032797cb5bc04fca69d5.jpg";